import commonApi from "@api/common";
import { useLayoutContext } from "@context/layout";
import { TAG_EXPERIMENT } from "@types";

const useSearchExperiments = () => {
  const { userData } = useLayoutContext();

  const commonSendingData = {
    tag: TAG_EXPERIMENT.SEARCH_AGA,
    user_id: userData?.user_id || null,
    age: userData?.user?.age || null,
    product_count: userData?.user?.num_order,
    product_count_free: userData?.user?.num_free_order,
  };

  const searchExperimentSubmitter = async (term: string) => {
    if (Boolean(userData?.is_login)) {
      try {
        const { tag, ...otherData } = commonSendingData;
        const res = await commonApi
          .submitLog({
            tag,
            anyJoson: {
              ...otherData,
              term,
            },
          })
          .fetch();
        return res;
      } catch (error) {
        console.log(error);
      }
    }
  };

  return searchExperimentSubmitter;
};

export default useSearchExperiments;
